"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function LegalDisclaimer() {
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const disclaimerSections = [{
    title: "General Information",
    content: "The information provided on this website is for general informational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information contained herein."
  }, {
    title: "Professional Advice",
    content: "The content on this website should not be considered as professional advice. Any reliance you place on such information is strictly at your own risk. We recommend consulting with qualified professionals for specific advice tailored to your individual circumstances."
  }, {
    title: "Limitation of Liability",
    content: "In no event shall we be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to or use of this website. This includes but is not limited to damages for loss of profits, data, or other intangible losses."
  }, {
    title: "External Links",
    content: "This website may contain links to external websites that are not provided or maintained by us. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites and are not responsible for their content."
  }, {
    title: "Changes to Disclaimer",
    content: "We reserve the right to modify this disclaimer at any time without prior notice. Your continued use of the website following any changes indicates your acceptance of the updated disclaimer. Please review this page periodically for updates."
  }];
  return <section className="relative bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <Card ref={cardRef} className={`bg-background-card shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${cardVisible ? "animate-fade-in-up" : "translate-y-4 opacity-0"}`}>
          <CardContent className="space-y-8">
            <div className="text-center">
              <h1 className={`text-foreground-light text-3xl font-bold sm:text-4xl lg:text-5xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "animate-fade-in-up-delay-100" : "translate-y-4 opacity-0"}`}>
                Legal Disclaimer
              </h1>
            </div>

            <div className="space-y-6">
              {disclaimerSections.map((section, i) => <div key={i} data-index={i}>
                  {i > 0 && <Separator className={`my-6 bg-secondary-400 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "animate-fade-in-up opacity-100" : "translate-y-4 opacity-0"}`} style={{
                animationDelay: `${120 * (i * 2)}ms`
              }} />}

                  <h2 className={`text-foreground-light mb-3 text-xl font-semibold sm:text-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "opacity-100" : "translate-y-4 opacity-0"}`} style={{
                animation: cardVisible ? `fade-in-up var(--duration-medium) var(--ease-smooth) both` : "none",
                animationDelay: `${120 * (i * 2 + 1)}ms`
              }}>
                    {section.title}
                  </h2>

                  <p className={`text-foreground-body leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "opacity-100" : "translate-y-4 opacity-0"}`} style={{
                animation: cardVisible ? `fade-in-up var(--duration-medium) var(--ease-smooth) both` : "none",
                animationDelay: `${120 * (i * 2 + 2)}ms`
              }}>
                    {section.content}
                  </p>
                </div>)}
            </div>

            <div className={`text-foreground-body mt-8 border-t border-secondary-400 pt-6 text-center text-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "opacity-100" : "translate-y-4 opacity-0"}`} style={{
            animation: cardVisible ? `fade-in-up var(--duration-medium) var(--ease-smooth) both` : "none",
            animationDelay: `${120 * disclaimerSections.length * 2}ms`
          }}>
              Last updated: {new Date().toLocaleDateString()}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}